import { ReadyForUser } from './main';

// @deprecated use UFO instead
export default ReadyForUser;
